export default class TravelServiceOrderItemRail {
  start_place_id = null;
  end_place_id = null;
  start_date = null;
  start_time = null;
  return_date = null;
  return_time = null;
  seat_class = null;
  is_insurance = false;
}
